import React from 'react';
import { Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LTLayout from '../../components/LTLayout';
import Loader from 'components/Loader';
import Routes from '../../routes';
import history from 'utils/history';
import usePlan from '../../hooks/usePlan';
import './style.css';

import AppBannerAndModals from './modals';

const toasterStyle = { top: 130 };

function App() {
  const { promoBannerHeight } = usePlan();

  let className = 'main-section mainContentWrapper';
  if (promoBannerHeight > 0) {
    className += ' bannerPadding';
  }

  return (
    <>
      <Toaster containerStyle={toasterStyle} position="top-right" />
      <LTLayout />
      <React.Suspense fallback={<Loader isSuspenseLoader={true} />}>
        <Router history={history}>
          <div className={className}>
            <AppBannerAndModals />
            <Routes history={history} />
          </div>
        </Router>
      </React.Suspense>
    </>
  );
}

export default App;
